import React from 'react';

import { useAppContext } from '../context';
import { useDeepEffect } from '@hooks';

type DynamicPageTitleProps = {
  children: React.ReactNode;
};

const DynamicPageTitle: React.FC<DynamicPageTitleProps> = ({ children }) => {
  const { addTitle } = useAppContext();

  useDeepEffect(() => {
    return addTitle(children);
  }, [children, addTitle]);

  return null;
};

export default React.memo(DynamicPageTitle) as typeof DynamicPageTitle;
